import { NgClass, NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, Type } from '@angular/core';
import { IconComponent } from '@examdojo/core/icon';
import { simpleCalloutColorClassMap } from '../../../editor/extensions/simple-callout';
import { CalloutColor, SimpleCalloutBlock } from '../../../model';

@Component({
  selector: 'dojo-simple-callout-block-renderer',
  template: `
    <div
      class="simple-callout flex items-start overflow-clip rounded-2xl border"
      [ngClass]="[block().custom_css ?? '', colorClasses().border, colorClasses().bg]"
    >
      <div class="flex flex-1 flex-col gap-2 p-4 md:gap-3 md:p-4">
        <div class="flex items-center gap-2">
          @if (block().icon) {
            <div class="shrink-0">
              <dojo-icon [icon]="block().icon!" [ngClass]="colorClasses().text" [size]="14" />
            </div>
          }
          <span class="text-xs font-bold uppercase leading-4" [ngClass]="colorClasses().text">
            {{ block().title }}
          </span>
        </div>

        <div class="simple-callout-content">
          <ng-container *ngComponentOutlet="contentRenderer(); inputs: { blocks: block().content }" />
        </div>
      </div>
    </div>
  `,
  styleUrls: ['../../../editor/extensions/simple-callout/simple-callout-shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NgComponentOutlet, NgClass],
})
export class SimpleCalloutBlockRendererComponent {
  readonly block = input.required<SimpleCalloutBlock>();
  readonly contentRenderer = input.required<Type<unknown>>();

  readonly colorClasses = computed(() => {
    const color = this.block().color ?? CalloutColor.Sky;
    return simpleCalloutColorClassMap[color];
  });
}
